module.exports = __webpack_public_path__ + "static/media/poste_14.486fe035.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_14.jpg
// module id = 242
// module chunks = 0